<template>
  <q-dialog v-model="show" persistent maximized align="center" square>
    <div class="security-dialog">
      <q-card class="testing" align="left">
        <security-t-f-conditions class="q-mt-md q-mb-md">
          <template #button>
            <div class="dialog-btn__wrap">
              <q-btn
                class="dialog-btn"
                color="green"
                data-testid="confirm-security"
                :label="t('confirmBtn')"
                @click="onAccept"
              />
            </div>
          </template>
        </security-t-f-conditions>
      </q-card>
    </div>
  </q-dialog>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import SecurityTFConditions from '@/components/security/SecurityConditions.vue';
import { useI18n } from 'vue-i18n';
import { useUsers } from '@/composables/useUsers';
import { useAuthStore } from '@/store/auth';

/*****************************************************************************
 * SETUP
 ****************************************************************************/
const { t } = useI18n();
const authStore = useAuthStore();
const { updateConfirmSecurityTFDate } = useUsers();

// responsiveness
const show = ref(false);

const onAccept = async () => {
  await updateConfirmSecurityTFDate(authStore.currentUser?.uuid as string);
  close();
};

const showDialog = (showvalue: boolean) => {
  show.value = showvalue;
};

const close = () => {
  show.value = false;
};

defineExpose({
  showDialog,
});
</script>
<style lang="scss" scoped>
@import 'styles/app.variables.scss';
@import 'styles/quasar.variables.scss';
.testing {
  width: 50%;
  height: 100%;
  background: rgb(167, 0, 28);

  @media screen and (max-width: $bp720) {
    width: 100%;
  }
}
.dialog-btn {
  width: 12rem;
  height: 60px;

  &__wrap {
    flex-wrap: nowrap;
    display: flex;
    justify-content: center;
    margin: 16px;
  }
}
:deep(.dialog-btn span.block) {
  color: white;
}
</style>
